
import React from 'react';

const IntroSection: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Introduction to Safety Staffing in Construction
          </h2>
        </div>
        
        <div className="grid lg:grid-cols-3 gap-8 items-start">
          {/* Left Column - Text Content */}
          <div className="lg:col-span-2 space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              HP Inc consulting services has provided safety manager staffing services to small, medium, and Fortune 500 companies throughout the US since 2008. HP Inc consulting services provides the site safety professional and administers all compensation.
            </p>
            
            <p className="text-lg text-gray-700 leading-relaxed">
              We can assist you with your safety staffing needs by providing qualified safety managers and safety coordinators to your company. Our safety professionals are experienced in construction, industrial, and manufacturing environments.
            </p>

            <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-orange-500">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Our Safety Staffing Services Include:
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 mt-1 mr-2"></i>
                  <span>Full-time and part-time safety managers</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 mt-1 mr-2"></i>
                  <span>Project-based safety coordinators</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 mt-1 mr-2"></i>
                  <span>Emergency response safety personnel</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 mt-1 mr-2"></i>
                  <span>Temporary safety coverage during transitions</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="lg:col-span-1">
            <div className="relative w-full h-full min-h-[400px] rounded-lg overflow-hidden shadow-lg">
              <img 
                src="https://static.readdy.ai/image/83c31d00f47a619d4f0a515f0b3bc954/a1248270a2738556bdd406862b4d36f8.png"
                alt="Safety Staffing for Large-Scale Projects"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
